import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RomeUiLoaderComponent } from './components/rome-ui-loader/rome-ui-loader.component';
import { ROME_UI_LOADER_CONFIG_TOKEN } from './config/rome-ui-loader-config.token';
import { RomeUiLoaderHttpInterceptor } from './interceptors/rome-ui-loader-http-interceptor';
import { RomeUiLoaderConfig } from './utils/interfaces';

@NgModule({
  imports: [CommonModule],
  declarations: [RomeUiLoaderComponent],
  exports: [RomeUiLoaderComponent]
})
export class RomeUiLoaderModule {
  /**
   * forRoot
   * @returns A module with its provider dependencies
   */
  static forRoot(romeUiLoaderConfig: RomeUiLoaderConfig): ModuleWithProviders<RomeUiLoaderModule> {
    return {
      ngModule: RomeUiLoaderModule,
      providers: [
        {
          provide: ROME_UI_LOADER_CONFIG_TOKEN,
          useValue: romeUiLoaderConfig
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: RomeUiLoaderHttpInterceptor,
          multi: true
        }
      ]
    };
  }
}
